export class DrugFileUpload {
    FileContent:string;
    FileName:string;
}
